import React from 'react'
import { ScrollView } from 'react-native'

// i18n
import I18n from 'APP/Services/i18n'

// Components
import Typography from 'APP/Converse/Typography'

// Styles
import {
  StyledView,
  StyledCard,
  TextWrapper,
  Title,
  StyledButton,
  ImageWrapper,
  Illustration,
} from './style'
import { Images } from 'APP/Themes'

const VerifyEmailSuccessScreen = ({ navigation }) => (
  <StyledView>
    <StyledCard>
      <ScrollView alwaysBounceVertical={false}>
        <ImageWrapper>
          <Illustration resizeMode="contain" source={Images.logoDiaBrand} />
        </ImageWrapper>
        <TextWrapper>
          <Title variant="h3">{I18n.t('VerifyEmailSuccessScreen.title')}</Title>
          <Typography variant="bodyNormal">
            {I18n.t('VerifyEmailSuccessScreen.subtitle')}
          </Typography>
        </TextWrapper>
        <StyledButton
          onPress={() => navigation.goBack()}
          analyticsName="VerifyEmailSuccessScreen.continueButtonLabel"
        >
          {I18n.t('VerifyEmailSuccessScreen.continueButtonLabel')}
        </StyledButton>
      </ScrollView>
    </StyledCard>
  </StyledView>
)

export default VerifyEmailSuccessScreen
